import { useRef } from 'react';
import { Helmet } from 'react-helmet'; // Importe o Helmet
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import Cores from '../../components/Cores';
import { useGameContext } from '../../contexts/GameContext';
import { Typography, CircularProgress, Box } from '@mui/material';

function shuffleObjectKeys(obj) {
    const keys = Object.keys(obj);
    for (let i = keys.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [keys[i], keys[j]] = [keys[j], keys[i]];
    }
    return keys;
}

const Feed = () => {
    const { homePageData, loadingHomePage, errorHomePage } = useGameContext();
    const firstCoresRef = useRef(null);
    const siteUrl = window.location.origin; // Obtém a URL base do site

    // Crie um título dinâmico baseado nos dados, se possível
    const pageTitle = 'emulador';
    const pageDescription = 'jogos e muito mais, sem limites';
    const pageImage = homePageData.banner?.box?.asset?.url;

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />

                {/* Meta tags para Open Graph (Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:url" content={siteUrl} />
                <meta property="og:type" content="website" />
                {pageImage && <meta property="og:image" content={pageImage} />}

                {/* Meta tags para Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                {pageImage && <meta name="twitter:image" content={pageImage} />}
            </Helmet>

            {loadingHomePage ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '100vh',
                        pb: 14,
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : errorHomePage ? (
                <Typography color="error" align="center" sx={{ mt: 4 }}>
                    {errorHomePage}
                </Typography>
            ) : (
                <Box sx={{ pb: 14, width: '100%' }}>
                    {homePageData.banner?.video?.asset?.url && (
                        <Banner banner={homePageData.banner} />
                    )}
                    <Box
                        sx={{
                            position: { lg: 'relative' },
                            zIndex: { lg: 1 },
                            // Aplica a margem superior dinamicamente APENAS se o banner estiver presente
                            mt: {
                                lg: homePageData.banner?.video?.asset?.url ? `-180px` : 2,
                                xs: homePageData.banner?.video?.asset?.url ? null : 2
                            },
                        }}
                    >
                        {shuffleObjectKeys(homePageData.cores).map((coreKey, index) => {
                            // Verifique se a chave que estamos iterando representa a lista de jogos
                            if (!coreKey.endsWith('_total') && Array.isArray(homePageData.cores[coreKey])) {
                                const totalJogos = homePageData.cores[coreKey + '_total'];
                                return (
                                    <Cores
                                        key={coreKey}
                                        core={coreKey}
                                        jogos={homePageData.cores[coreKey]}
                                        totalJogos={totalJogos} // Passando o total de jogos
                                        ref={index === 0 ? firstCoresRef : null}
                                    />
                                );
                            }
                            return null;
                        })}
                    </Box>
                </Box>
            )}
            <Navbar />
        </>
    );
};

export default Feed;